import { ColumnDef } from "@tanstack/react-table";
import { z, ZodObject, ZodRawShape } from "zod";
import { useTranslation } from "react-i18next";

export const WarehouseTableColumns: ColumnDef<
  z.infer<ZodObject<ZodRawShape>>
>[] = [
  {
    accessorKey: "name",
    header: "name",
  },
  {
    accessorKey: "code",
    header: "code",
  },
  {
    accessorKey: "status",
    header: "status",
    cell: ({ row }) => {
      const { t } = useTranslation("common");

      if (row.original.status === true) {
        return t("Active");
      }

      return t("Inactive");
    },
  },
  {
    accessorKey: "calloff_rule",
    header: "calloff_rule",
  },
];
